<template>
  <div class="edit-rental">
    <a-form layout="vertical" v-if="currentLivingConditionObject !== null">
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Huurcontract staat op naam van">
            <a-radio-group v-if="isMainCustomer"
                           v-model="customerProperty.contract_owner"
                           v-bind:disabled="disabled"
                           button-style="solid" v-on:change="handleContractOwnerChanged">
              <a-radio-button value="main_customer">
                {{ customerName }}
              </a-radio-button>
              <a-radio-button v-if="hasPartner" value="partner">
                {{ partnerName }}
              </a-radio-button>
              <a-radio-button v-if="hasPartner" value="both">
                Beide
              </a-radio-button>
              <a-radio-button value="other">
                Anders
              </a-radio-button>
            </a-radio-group>
            <a-radio-group v-else
                           v-model="customerProperty.contract_owner"
                           v-bind:disabled="disabled"
                           button-style="solid" v-on:change="handleContractOwnerChanged">
              <a-radio-button value="main_customer">
                {{ partnerName }}
              </a-radio-button>
              <a-radio-button v-if="hasPartner" value="partner">
                {{ customerName }}
              </a-radio-button>
              <a-radio-button v-if="hasPartner" value="both">
                Beide
              </a-radio-button>
              <a-radio-button value="other">
                Anders
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col v-bind:span="12"></a-col>
      </a-row>
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Kale huur">
            <a-input style="display:block;"
                     prefix="€"
                     type="Number"
                     v-model="currentLivingConditionObject.basic_rent"
                     v-on:change="onChange"
            />
          </a-form-item>
        </a-col>
        <!--        <a-col v-bind:span="12">-->
        <!--          <a-form-item label="Servicekosten">-->
        <!--            <a-input-->
        <!--                prefix="€"-->
        <!--                style="display:block;"-->
        <!--                type="Number"-->
        <!--                v-model="currentLivingConditionObject.service_costs"-->
        <!--                v-on:change="onChange"-->
        <!--            />-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->
      </a-row>
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Overige kosten">
            <a-input
                prefix="€"
                type="Number"
                v-model="currentLivingConditionObject.other_costs"
                v-on:change="onChange"
            />
          </a-form-item>
        </a-col>
        <a-col v-bind:span="12">
          <a-form-item label="Jaarlijkse huurtstijging">
            <percentage-input
                style="display:block;"
                v-model="currentLivingConditionObject.rental_increase_rate"
                v-on:change="onChange"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row v-bind:gutter="16">

        <a-col v-bind:span="12">
          <a-form-item label="Datum huurcontract">
            <date-picker-component v-bind:block="true"
                                   v-model="currentLivingConditionObject.since"
                                   v-on:change="onChangeDateField($event, 'since')"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import customerCurrentLivingConditionApi from '~/api/customer_current_living_condition';

export default {
  name: "EditRentalComponent",
  components: {},
  props: {
    value: {
      required: true,
      type: Object
    },
    autoSave: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      currentLivingConditionObject: null,
      persistTimeout: 0
    }
  },
  computed: {},
  mounted() {
    this.currentLivingConditionObject = this.value;
  },
  methods: {
    onChange() {
      this.$emit('input', this.currentLivingConditionObject);
      this.$emit('change', this.currentLivingConditionObject);

      if (this.autoSave) {
        this.save();
      }
    },
    onChangeDateField(moment, key) {
      this.currentLivingConditionObject[key] = moment.format()
      if (this.autoSave) {
        this.save();
      }
    },
    save() {
      clearTimeout(this.persistTimeout)

      this.persistTimeout = setTimeout(() => {
        customerCurrentLivingConditionApi.update(this.currentLivingConditionObject).then(() => {
          this.$emit('save', this.currentLivingConditionObject);
        }).catch((error) => {
          this.$message.error('Er ging iets fout tijdens het opslaan');
          this.$emit('error', error);
        });
      }, 500)
    }
  },
}
</script>
<style scoped>
</style>
